import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { LinkButton, Button } from '~/lib/ui/button'
import { cn } from '~/lib/utils'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '~/hooks/useTranslation'

const ResumeTailoringDialog = ({
  buttonUrl,
  buttonText,
  className,
  disabled,
}) => {
  const [open, setOpen] = useState(false)
  const {
    current_user: {
      candidate_first_name: candidateFirstName,
      completed_services: completedServices,
    } = {},
  } = useBenefits()
  const { t } = useTranslation(
    'ProfessionalServices.ResumeTailoring.ResumeTailoringDialog',
  )

  const resumeDevelopmentCompleted = completedServices?.includes('ResumeReview')

  const onOpenChange = (isOpen) => {
    if (isOpen && resumeDevelopmentCompleted) {
      window.location.href = buttonUrl
    } else {
      setOpen(isOpen)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange} className="rounded-2xl">
      <DialogTrigger asChild className="cursor-pointer">
        {className ? (
          <Button className={className} disabled={disabled}>
            {buttonText || t('get_started')}
          </Button>
        ) : (
          <Button
            variant="coachcta"
            className={cn(disabled && 'pointer-events-none opacity-60')}
            disabled={disabled}
          >
            {buttonText || t('get_started')}
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="md:max-w-[50.5rem]">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            {t('best_practices')}
          </DialogTitle>
        </DialogHeader>
        <div className="mx-4 mb-4">
          <p>{t('greeting', { firstName: candidateFirstName })}</p>
          <p>{t('content')}</p>
          <div className="mt-6 flex flex-col justify-evenly gap-2 md:flex-row md:flex-wrap">
            <LinkButton variant="outline" href="/coach_services/resume_review">
              {t('actions.resume_development')}
            </LinkButton>
            <LinkButton href={buttonUrl}>
              {t('actions.continue_anyways')}
            </LinkButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ResumeTailoringDialog
